import { Goal, ID } from '@griply/types';

export const filterGoalsOnLifeArea = (goals: Goal[], lifeAreaId: ID) =>
  goals.filter(
    (goal) =>
      lifeAreaId === goal.lifeAreaId && !goal.archivedAt && !goal.parentIds,
  );
